import React from 'react'
import PropTypes from 'prop-types'

import { Card, CardContent, Typography } from '@mui/material';
import palette from '../../theme/palette';

const InnerCard = ({ type, value, sx = {} }) => {
  return (
    <Card sx={{ height: '100%', border: 1, borderColor: palette.grey[500], ...sx }}>
      <CardContent>
        <Typography
          variant="inherit"
          sx={{ color: palette.grey[500] }}
        >
          {type}
        </Typography>
        <Typography
          variant="inherit"
          sx={{ fontWeight: "bold", }}
        >{value}
        </Typography>
      </CardContent>
    </Card>
  );
}

InnerCard.propTypes = {

  type: PropTypes.string.isRequired,

  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default InnerCard;
